module.exports = __webpack_public_path__ + "img/no-select-paper.56aefaec.png";